import { isMatch, parse, format, getUnixTime, addDays, addMonths, getDaysInMonth, setDate } from 'date-fns';
import { pickBy } from 'lodash';

const MONTH_FORMAT = 'yyyy-MM';
const DATE_FORMAT = 'yyyy-MM-dd';

export const datePeriodToTimestamps = ({ from, to }) => pickBy({
  from: from ? getUnixTime(parse(from, DATE_FORMAT, new Date())) : null,
  to: to ? getUnixTime(addDays(parse(to, DATE_FORMAT, new Date()), 1)) : null,
});

export const isValidDateString = (dateString) => {
  if (!isMatch(dateString, DATE_FORMAT)) {
    return false;
  }

  // Because some dates like '2025-1-5' will still match the format
  // we also do a roundtrip check to have exact match to the format
  const parsedDate = parse(dateString, DATE_FORMAT, new Date());
  return format(parsedDate, DATE_FORMAT) === dateString;
};

export const addToMonthString = (monthString, months) =>
  format(addMonths(parse(monthString, MONTH_FORMAT, new Date()), months), MONTH_FORMAT);

export const datesOfMonth = (monthString) => {
  const monthStart = parse(monthString, MONTH_FORMAT, new Date());
  const days = getDaysInMonth(monthStart);
  const result = [];
  for (let i = 1; i <= days; i += 1) {
    result.push(format(setDate(monthStart, i), DATE_FORMAT));
  }
  return result;
};
